// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1RXeo","title":"BackImages_title__1Hzvp","images":"BackImages_images__1Q6ft"};